import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=fbacedc8"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=fbacedc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports